import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';
import VideoMob from './VideoMob.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';




let strvideo = [];

strvideo.push( <video key="strvideo" width="auto" height="450vh" autoPlay={true} muted={true} mute="true" playsInline={true} loop={true} disablePictureInPicture={true} onCanPlay={strCanPlay} src={window.VIDEOTEKSTIT.kolmasosiovideo} type="video/mp4" /> );

function strCanPlay(e)
{
	//console.log(e);
	//console.log("I can now play in Str");
	window.videoVideoCanPlay = true;
}

let firstStrLoad = true;

let stopupdates = function () {};


function Video(p)
{
	React.useEffect( () => { if ( window.RECENTLOAD ) window.drawVideo() } );
	let [progress, pupdate] = React.useState(0);
	let [progressLp, pupdateLp] = React.useState(0);
	let [nomoreload, nomoreupdate] = React.useState(<div></div>);

	stopupdates = nomoreupdate;


	if (! (window.KAIKKIVIDEOKUVATLADATTU && window.videoVideoCanPlay) )
	{
		let loopy = () =>
		{
			if (! (window.KAIKKIVIDEOKUVATLADATTU && window.videoVideoCanPlay) )
			{
				//console.log("Kaikki " + window.KAIKKIVIDEOKUVATLADATTU + " video " + window.videoVideoCanPlay);
				setTimeout(loopy, 500);
			}
			else
			{
				//console.log("No more loopy");
				let empty = [];
				stopupdates(empty);

			}
			pupdate((window.allmedia.video.length + window.allmedia.videov.length) + " images out of " + window.allmedia.videos);
			let addition = 0;
			if (window.videoVideoCanPlay) addition = 10;
			pupdateLp((90 * (window.allmedia.video.length/window.allmedia.videos)) + addition );
		};
		setTimeout(loopy, 1000);
		let cont = [];
		if (firstStrLoad) firstStrLoad = false;
		else cont = strvideo;
		return(	<div><ThemeProvider theme={window.MUIthemeWhite}>
			<div className="keskitetty" style={{color: "#000000", fontSize: "125%"}}>
				<div>Ladataan:</div>
				<div>
    	  				<LinearProgress variant="determinate" value={progressLp} />
				</div>
			</div></ThemeProvider><div style={{ display:"none" }}> {cont} {nomoreload} </div> </div>);
	}
	else
	{
		if (isMobile && window.NOTIPAD)
		{
			return (<VideoMob strvideo={strvideo}/>);
		}
		else
		{

			return (<div style={{color: "#000000", fontSize: "125%"}}>
				<div key="videoosioeka" className="kuvallinenvasen">
					<div>
						<h1>{window.VIDEOTEKSTIT.ekaosio}</h1>
						<div key="gapihmomia" className="otsikkogap"></div>
						{window.VIDEOTEKSTIT.ekaosioekar}
						<div key="gapihmomib" className="paragap"></div>
						{window.VIDEOTEKSTIT.ekaosiotokar}
					</div>
					<div></div><div></div>
				</div>
				<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
				<div key="gapihmomic" className="osiogap"></div>
				<div key="videoosiotoka" className="kuvallinenvasen">
					<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
						<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
							<h3>{window.VIDEOTEKSTIT.tokaosioekar}</h3>
						</div>
					</div>
					<div>
						<img height="300vh" src={window.VIDEOTEKSTIT.tokaosiokuva} /><br/>
						{window.VIDEOTEKSTIT.tokaosiokuvateksti}
					</div>
				</div>
				<BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" />
				<div key="gapihmomid" className="osiogap"></div>
				<div key="videoosiotokab" className="kuvallinenoikeavasmargi">
					<div>
						<div style={{position: "absolute", clipPath: "polygon(16% 7%, 16% 100%, 92% 100%, 92% 7%)" }}>
							{strvideo}
						</div>
						<div style={{position: "absolute"}}>
							<img height="500vh" src={window.VIDEOTEKSTIT.kolmasosiokuva} />
						</div>
					</div>
					<div></div>
					<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
						<div style={{height:"10vh"}}></div>
						<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
							<div>{window.VIDEOTEKSTIT.kolmasosioekar}</div>
							<div key="gapihmomie" className="osiogap"></div>
							<h3>{window.VIDEOTEKSTIT.kolmasosiotokar}</h3>
						</div>
					</div>
				</div>
				<div key="gapihmomif" className="osiogap"></div>
				<div key="gapihmomifa" className="osiogap"></div>
				<div key="gapihmomifb" className="osiogap"></div>
				<div key="gapihmomifc" className="osiogap"></div>
				<div key="gapihmomifba" className="osiogap"></div>
				<div key="gapihmomifcb" className="osiogap"></div>


				<div key="videoosiotokac" className="kuvallinenoikeavasmargi">
					<div>
						<img height="300vh" src={window.VIDEOTEKSTIT.neljasosiokuva} />
					</div>
					<div></div>
					<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
						<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
							<h3>{window.VIDEOTEKSTIT.neljasosio}</h3>
							<div key="gapihmomig" className="osiogap"></div>
							<div>{window.VIDEOTEKSTIT.neljasosioekar}</div>
						</div>
					</div>
				</div>
				<div key="gapihmomih" className="osiogap"></div>
				<div key="videoosioekad" className="kuvallinenvasen">
					<div>
						<h2>{window.VIDEOTEKSTIT.viidesosio}</h2>
						<div key="gapihmomii" className="otsikkogap"></div>
						{window.VIDEOTEKSTIT.viidesosioekar}
						<div key="gapihmomij" className="paragap"></div>
						{window.VIDEOTEKSTIT.viidesosiotokar}
					</div>
					<div></div><div></div>
				</div>

				<div key="videoosiotokaf" className="kuvallinenoikeavasmargi">
					<div>
					</div>
					<div></div>
					<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
						<div className="lenkkari" style={{transform: "translate(-5em, -1em)"}}>
							<img height="300vh" src={window.VIDEOTEKSTIT.kuudesosiokuva} />
						</div>
					</div>
				</div>

				<div key="videoosiotokag" className="kuvallinenoikeavasmargi">
					<div>
					</div>
					<div></div>
					<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
						<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
							<div>{window.VIDEOTEKSTIT.kuudesosioekar}</div>
							<div key="gapihmomik" className="osiogap"></div>
							<div>{window.VIDEOTEKSTIT.kuudesosiotokar}</div>
						</div>
					</div>
				</div>

				<div key="gapihmomil" className="osiogap"></div>


				<div key="gapihmomio" className="osiogap"></div>
		<div key="gapihmomihe" className="osiogap"></div>
		<div className="vasen" style={{fontSize:"0.5em"}}>
				{window.VIDEOTEKSTIT.sivunalateksti}
		</div>


				<div className="seuraavasivu">
					<div className="seuraavasivuotsikko">
						<Link to="../" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKaruselli}>
							<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>ALKUUN</span>
						</Link>
					</div>
					<div style={{transform: "scale(0.75)"}}>
						<Link to="../" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKaruselli}>
							<ArrowRight stroke="#000000"/>
						</Link>
					</div>
				</div>


			</div>);
		}
	}
}


function moveToKaruselli()
{
	window.SETKARUSELLI();
	window.drawKar();
}




export default Video;
